/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createInvoiceDtoFromDiscriminatorValue, serializeApplyDiscountRequest, serializeInvoiceDto, serializeRemoveDiscountRequest, type ApplyDiscountRequest, type ErrorResponse, type InternalErrorResponse, type InvoiceDto, type RemoveDiscountRequest } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/invoices/{invoiceId}/discount
 */
export interface DiscountRequestBuilder extends BaseRequestBuilder<DiscountRequestBuilder> {
    /**
     * Clears the invoice-level discount and puts the total back to subtotal plus shipping plus tax. It carries the same restriction as applying one: allowed in any status, refused as soon as anything is paid, so refund the payments first. Removing a discount from an invoice that has none succeeds and changes nothing, so the call is safe to repeat. Per-line discounts are not affected.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<InvoiceDto>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     delete(body: RemoveDiscountRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<InvoiceDto | undefined>;
    /**
     * Sets the single invoice-level discount, replacing whatever was there before. It comes off the subtotal, before shipping and tax, so the total becomes subtotal plus shipping plus tax minus the discount. Type is Amount for a flat sum in the invoice's currency or Percentage for a share of the subtotal; the value cannot be negative and a percentage cannot exceed 100. What the call turns on is money, not status — it works on a draft or an issued invoice alike, but is refused as soon as anything is paid, so refund the payments first. Per-line discounts are set when the line is created and are untouched here. An unrecognised type is stored as Amount rather than rejected. On an invoice carrying imported totals the discount is recorded but the imported total still stands, so the amount owed does not move.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<InvoiceDto>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: ApplyDiscountRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<InvoiceDto | undefined>;
    /**
     * Clears the invoice-level discount and puts the total back to subtotal plus shipping plus tax. It carries the same restriction as applying one: allowed in any status, refused as soon as anything is paid, so refund the payments first. Removing a discount from an invoice that has none succeeds and changes nothing, so the call is safe to repeat. Per-line discounts are not affected.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toDeleteRequestInformation(body: RemoveDiscountRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * Sets the single invoice-level discount, replacing whatever was there before. It comes off the subtotal, before shipping and tax, so the total becomes subtotal plus shipping plus tax minus the discount. Type is Amount for a flat sum in the invoice's currency or Percentage for a share of the subtotal; the value cannot be negative and a percentage cannot exceed 100. What the call turns on is money, not status — it works on a draft or an issued invoice alike, but is refused as soon as anything is paid, so refund the payments first. Per-line discounts are set when the line is created and are untouched here. An unrecognised type is stored as Amount rather than rejected. On an invoice carrying imported totals the discount is recorded but the imported total still stands, so the amount owed does not move.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: ApplyDiscountRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const DiscountRequestBuilderUriTemplate = "{+baseurl}/api/invoices/{invoiceId}/discount";
/**
 * Metadata for all the requests in the request builder.
 */
export const DiscountRequestBuilderRequestsMetadata: RequestsMetadata = {
    delete: {
        uriTemplate: DiscountRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createInvoiceDtoFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeRemoveDiscountRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
    post: {
        uriTemplate: DiscountRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createInvoiceDtoFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeApplyDiscountRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
